import React, { useState } from 'react';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({ name: '', email: '', phone: '', message: '' });
    }, 4000);
  };

  return (
    <section className="contact">
      <div className="hero contact-hero">
        <div className="hero-overlay">
          <h1>Contact Heifersaero</h1>
          <p>Your source for premium aero spare parts and solutions.</p>
        </div>
      </div>
      <main className="content">
        <div className="contact-form-container">
          <h2>Get in Touch</h2>
          <p className="form-subtitle">Need spare parts or support? We’ve got you covered.</p>
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-field">
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                maxLength="100"
                required
                placeholder=" "
                className="form-input"
              />
              <label htmlFor="name" className="form-label">Full Name</label>
            </div>
            <div className="form-field">
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                maxLength="250"
                required
                placeholder=" "
                className="form-input"
              />
              <label htmlFor="email" className="form-label">Email Address</label>
            </div>
            <div className="form-field">
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                maxLength="50"
                placeholder=" "
                className="form-input"
              />
              <label htmlFor="phone" className="form-label">Phone Number</label>
            </div>
            <div className="form-field">
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="6"
                required
                placeholder=" "
                className="form-input"
              />
              <label htmlFor="message" className="form-label">Your Inquiry</label>
            </div>
            <button type="submit" className="submit-btn" disabled={isSubmitted}>
              {isSubmitted ? (
                <span className="btn-success">Sent Successfully</span>
              ) : (
                'Submit Inquiry'
              )}
            </button>
            {isSubmitted && (
              <p className="success-message">
                Thank you! Our team will respond promptly.
              </p>
            )}
          </form>
        </div>
      </main>
    </section>
  );
}

export default Contact;